import { render, staticRenderFns } from "./Requirement.vue?vue&type=template&id=bc65a664&scoped=true"
import script from "./Requirement.vue?vue&type=script&lang=js"
export * from "./Requirement.vue?vue&type=script&lang=js"
import style0 from "./Requirement.vue?vue&type=style&index=0&id=bc65a664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc65a664",
  null
  
)

export default component.exports